export default __webpack_public_path__ + "static/media/logo.948d71b8.svg";